// extracted by mini-css-extract-plugin
export default {"startSoon":"StartSoon_startSoon__xSYU4","register":"StartSoon_register__L1Sba","waiting":"StartSoon_waiting__41ob9"};